import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import { post, Token } from '../../../Script/Session';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Tab, tabClasses, Table, TabList, TabPanel, Tabs } from '@mui/joy';
import TeilnehmerViewer from './TeilnehmerViewer';
import DateiViewerAktivity from './DateiViewerAktivity';
import ViewPointsEntries from './ViewPointsEntries';
import AktivityEditor from './AktivityEditor';

function AktivityViewer() {
  const [wit, setWit] = useState("90.5%");
  const [data, setdata] = useState();
  const { id } = useParams();
  useEffect(() => {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    body.targetid = Number(id);
    let response = post(body, "/aktivitäten");
    setdata(JSON.parse(response));
    console.log(response);
  }, []);
  function update() {
    let body = {};
    body.token = Token.get();
    body.action = "get";
    body.targetid = Number(id);
    let response = post(body, "/aktivitäten");
    setdata(JSON.parse(response));
  }
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  return (
    <>
      <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", }}>
        <Tabs  value={tabIndex} onChange={(event, newValue) => {
          if (newValue == 3){
            navigate("/page-history/aktivität_" + data.id);
            return;
          }
          setTabIndex(newValue)
        }} sx={{ width: "100%", overflowY: "auto" }} defaultValue={0}>
          <TabList
            sx={{
              pt: 1,
              justifyContent: 'center',
              [`&& .${tabClasses.root}`]: {
                flex: 'initial',
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'transparent',
                },
                [`&.${tabClasses.selected}`]: {
                  color: 'primary.plainColor',
                  '&::after': {
                    height: 2,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    bgcolor: 'primary.500',
                  },
                },
              },
            }}
          >
            <Tab>Übersicht</Tab>
            <Tab>Teilnehmer</Tab>
            <Tab>Dateien</Tab>
            <Tab>Historie</Tab>
            <Tab>Manuelle Punktevergabe</Tab>
            <Tab>Bearbeiten</Tab>
          </TabList>
          <TabPanel value={0}>
            <Table sx={{
              '& td': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                // oder z. B. '20ch'
              },
            }}>
              <thead>
                <tr>
                  <th>Feld</th>
                  <th>Wert</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Title</td>
                  <td>{data?.title}</td>
                </tr>
                <tr>
                  <td>Ersteller</td>
                  <td>{data?.ersteller.vorname} {data?.ersteller.nachname}</td>
                </tr>
                <tr>
                  <td>Anfang</td>
                  <td>{data && new Date(data?.datum)?.toISOString().slice(0, 16).replace("T", " ")}</td>
                </tr>
                <tr>
                  <td>Vorausichtliches Ende</td>
                  <td>{data && new Date(data?.ende)?.toISOString().slice(0, 16).replace("T", " ")}</td>
                </tr>
                <tr>
                  <td>Leiter</td>
                  <td>{data?.leiter.name}</td>
                </tr>
                <tr>
                  <td>Protokollführer</td>
                  <td>{data?.protokollführer.name}</td>
                </tr>
                <tr>
                  <td>Ort</td>
                  <td>{data?.ort}</td>
                </tr>
                <tr>
                  <td>Thema</td>
                  <td>{data?.thema}</td>
                </tr>
                <tr>
                  <td>Gäste</td>
                  <td>{data?.gäste}</td>
                </tr>
                <tr>
                  <td>Veranstalter</td>
                  <td>{data?.veranstalter}</td>
                </tr>
                <tr>
                  <td>Kosten</td>
                  <td>{data?.kosten}</td>
                </tr>
              </tbody>
            </Table>
          </TabPanel>
          <TabPanel sx={{overflowY: "auto"}} value={1}>
            <TeilnehmerViewer data={data} update={update} />
          </TabPanel>
          <TabPanel sx={{overflowY: "auto"}} value={2}>
            <DateiViewerAktivity data={data} update={update} />
          </TabPanel>
          <TabPanel sx={{overflowY: "auto"}} value={4}>
            <ViewPointsEntries data={data} update={update}/>
          </TabPanel>
          <TabPanel sx={{overflowY: "auto"}} value={5}>
            <AktivityEditor data={data} update={update}/>
          </TabPanel>
        </Tabs>
      </div>
      <NavigationBar state={"home"} back={false} />
    </>
  )
}

export default AktivityViewer
